export default "__VITE_ASSET__CnqeMYHg__"